import React from 'react';
import { useAppContext } from "../CEF/Providers";
import { CheckEligibilityRouter } from "../CEF/CheckEligibilityRouter";
import { OnboardingRouter } from "../StudentOnboarding/OnboardingRouter";
var Router = function Router(_ref) {
  var initialPath = _ref.initialPath,
    onClose = _ref.onClose,
    onSave = _ref.onSave;
  var _useAppContext = useAppContext(),
    onboardingMode = _useAppContext.onboardingMode;
  return onboardingMode ? /*#__PURE__*/React.createElement(OnboardingRouter, {
    onExit: onClose,
    onSave: onSave
  }) : /*#__PURE__*/React.createElement(CheckEligibilityRouter, {
    initialPath: initialPath,
    onExit: onClose,
    onSave: onSave
  });
};
export default Router;